

















































import TransitionMixins from "@/mixins/TransitionMixins"
import { Component, Mixins } from "vue-property-decorator"
import { mapState } from "vuex"

@Component({
  components: {},
  computed: {
    ...mapState("Anzsco", {
      selectedOccupation: "selectedOccupation",
    }),
    ...mapState("RiskProfile", {
      newRiskProfile: "newRiskProfile",
      searchOptions: "searchOptions",
    }),
  },
})
export default class AnzscoOccupationSelect extends Mixins(TransitionMixins) {
  search = ""

  items = []
  searchCount = 0

  newRiskProfile!: NewRiskProfile
  searchOptions!: {
    query: string | null;
  }
  selectedOccupation!: Nullable<Model>

  get options() {
    return this.searchOptions
  }

  set options(value) {
    this.$store.commit("RiskProfile/SET_SEARCH_OPTIONS", value)
  }

  get selected() {
    return this.selectedOccupation?.id ?? null
  }

  get isSelected() {
    return !!this.selected
  }

  setSelection(item) {
    if (item.id !== this.selected) {
      this.newRiskProfile.description = item.job_description || ""
      this.$store.commit("Anzsco/SET_SELECTED_OCCUPATION", item)
      this.$store.commit("RiskProfileTemplate/RESET_STATE", [
        "selectedTemplate",
        "riskProfileTree",
      ])
    } else {
      this.$store.commit("Anzsco/CLEAR_STATE")
    }
  }

  handleFetchJobList(query, page, itemsPerPage) {
    if (query.length > 2) {
      if (!this.selectedOccupation?.name?.includes(query)) {
        this.$store.commit("Anzsco/SET_SELECTED_OCCUPATION", null)
      }
      return this.$store
        .dispatch("Anzsco/fetchList", {
          params: {
            search_name: query,
            page: page,
            per_page: itemsPerPage,
          },
        })
        .then((response) => {
          this.searchCount++
          return response
        })
    }
    return {
      items: [],
      total: 0,
    }
  }

  closeQuery() {
    this.options.query = null
    this.$store.commit("Anzsco/CLEAR_STATE")
  }
}
